<template>
    <div>
        <v-layout row justify-center>
            <v-dialog  v-model="summaryPopup"  class="popup-scoring" id="close-summary-popup">
                <v-card class="popup-scoring summary-popup">
                    <v-card-title class="headline color-on-primary-text bg-color-primary">
                        <span class="font-weight-regular">{{text('api.summary.communication.title')}}</span>
                        <span  @click="hideSummaryPopup()" class="float-right cursor-pointer">
                            <close-icon :svg-fill-class="'svg-on-primary-color'"/>
                        </span>
                    </v-card-title>
                    <v-card-text class="summary-content" ref="vCardTextSummaryContentRef">
                        <summary-content v-if="datasummary"></summary-content>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-layout>
    </div>
</template>

<!-- ################################################################## -->

<script>
import {mapActions, mapGetters} from 'vuex';
import SummaryContent from '../../../common/components/shared/SummaryContent';
import CloseIcon from "../../../common/components/svg/shared/closeIcon";

export default {
        name: 'SummaryPopup',

        components: {
            CloseIcon,
            SummaryContent
        },

        data () {
            return {
                valid: false,
                email: '',
                checkbox: false,
                emailRules: [
                    (value) => (value || "").length > 0 || this.text("api.error.field.required"),
                    (value) => {
                        let regex = /^(([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,15}|[0-9]{1,3})(\]?)(\s*\040\s*|\s*$))*$/;
                        return regex.test(value) || this.text("api.error.email.invalid");
                    }
                ]
            }
        },

        computed: {
            ...mapGetters({
                mustShowSummaryPopup: 'ScoringStore/getMustShowSummaryPopup',
                datasummary: 'SummaryStore/getSummaryDataNew',
                getAppPropertyValue: 'TranslationStore/getAppPropertyValue'
            }),

            summaryPopup: {
                get() {
                    return this.mustShowSummaryPopup;
                },

                set(newVal) {
                    if(newVal === false) {
                        this.hideSummaryPopup();
                    }
                }
            }
        },

        methods: {
            ...mapActions({
                showSummaryPopup: 'ScoringStore/showSummaryPopup'
            }),

            hideSummaryPopup() {
                this.$store.commit('ScoringStore/setMustShowSummaryPopup', false);
            },

            /*******************************
             ***   KEYBOARD NAVIGATION   ***
             ***      BEGIN CODE         ***
             *******************************/

            handleKeyDowns(event) {

                switch (event.keyCode) {

                    // Tab
                    case 9:
                        event.preventDefault();
                        event.stopPropagation();
                        event.stopImmediatePropagation();
                        return false;
                }

                if (this.mustShowSummaryPopup === false) {
                    return;
                }

                switch (event.keyCode) {

                    // Backspace
                    case 8:
                        event.preventDefault();
                        event.stopPropagation();
                        event.stopImmediatePropagation();
                        return false

                    // Escape
                    case 27:
                        this.hideSummaryPopup();
                        break;

                    // PageUp
                    case 33:
                        this.$refs["vCardTextSummaryContentRef"].scrollTop -= 50;
                        break;

                    // PageDown
                    case 34:
                        this.$refs["vCardTextSummaryContentRef"].scrollTop += 50;
                        break;

                    // M
                    case 77:
                        // ALT + M
                        if (event.shiftKey === false && event.altKey === true && event.ctrlKey === false) {
                            // focus on textarea comment
                            event.preventDefault();
                            this.hideSummaryPopup();
                            this.navPatientCommentFocusFromPopup();
                        }
                        break;
                }
            },

            handleKeyUps(event) {

                switch (event.keyCode) {

                    // Tab
                    case 9:
                        event.preventDefault();
                        event.stopPropagation();
                        event.stopImmediatePropagation();
                        return false;
                }
            },

            navPatientCommentFocusFromPopup() {

                // Activate navigation on MyDecisionPanel and PatientComment textarea
                if (this.$parent.shortcutNav.isKeyboardNav === false) {
                    // Entering in navigation mode
                    this.$parent.shortcutNav.isKeyboardNav = true;
                }

                this.$parent.shortcutNav.crtPanel = "MY_DECISION";
                this.$parent.shortcutNav.crtField = "PATIENT_COMMENT";

                this.$parent.navScrollOnActivePanel();

                /**
                 * Focus on patient comment textarea. Add border with primary color, for 1 second.
                 */
                let that = this.$parent;
                if (this.$parent.getIsAssessmentSealed === true) {
                    setTimeout(function () {
                        that.shortcutNav.crtField = null
                    }, 500);
                }

                // Patient comment Textarea will be directly editable if the panel is not disabled
                if (this.$parent.getIsAssessmentSealed === false) {
                    this.$parent.shortcutNav.isFieldInEdit = true;
                }

                // Sanity assignment for having the same configuration
                this.$parent.shortcutNav.isPanelHighlight = false;

                this.$parent.$refs['PATIENT_COMMENT'].$refs.input.focus();
            }

            /*******************************
             ***   KEYBOARD NAVIGATION   ***
             ***        END CODE         ***
             *******************************/

        },

        created: function() {
            document.addEventListener('keydown', this.handleKeyDowns);
            document.addEventListener('keyup', this.handleKeyUps);
        },

        destroyed: function() {
            document.removeEventListener('keydown', this.handleKeyDowns);
            document.removeEventListener('keyup', this.handleKeyUps);
        }

    }
</script>

<!-- ################################################################## -->

<style lang="scss" scoped>


    .assessment-generalquestions-table {
        width: 100%;
        padding-top:12px;
        padding-bottom: 12px;
        border-collapse:separate;
        border-spacing: 0 5px;

        .q-name {
            width: 18%;
        }

        .q-text {
            width: 65%;
            padding-right: 30px;
        }

        .a-text {
            width: 17%;
        }

        tr {
            background-color: #e2e2e2 !important;
            margin-bottom: 5px;
            border-radius: 5px;

            td {
                padding-top: 12px;
            }
        }

        tr td:first-child {
            border-top-left-radius: 5px;
            border-bottom-left-radius: 5px;
        }
        tr td:last-child { border-top-right-radius: 5px;
            border-bottom-right-radius: 5px;; }
    }

    .assessment-content-table{
        width: 100%;

        td {
            vertical-align: top !important;
        }
    }

</style>





// WEBPACK FOOTER //
// src/professional/components/scoring/SummaryPopup.vue